(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["informtaions-product"] && !Shopify.designMode) return;
  try {
    

console.log('🚀 Script Fairly Made tracking chargé !');

document.addEventListener('DOMContentLoaded', function () {
    console.log('📄 Page chargée, setup tracking Fairly Made...');

    const tracabiliteDiv = document.querySelector('.tracabilite');

    if (tracabiliteDiv) {
        console.log('✅ Div .tracabilite trouvé !', tracabiliteDiv);

        tracabiliteDiv.addEventListener('click', function (e) {
            console.log('🎯 CLIC sur .tracabilite détecté !');

            if (typeof gtag !== 'undefined') {
                gtag('event', 'fairly_made_click', {
                    'event_category': 'fairly_made',
                    'event_label': 'tracabilite_button_click',
                    'value': 1
                });
                console.log('📊 GA Event envoyé: fairly_made_click');
            }
        });
    } else {
        console.log('❌ Div .tracabilite non trouvée');
    }

    const popupOverlay = document.querySelector('.popup--overlay');

    if (popupOverlay) {
        console.log('✅ Popup overlay trouvé !');

        let popupOpened = false;

        const popupObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    const popup = mutation.target;
                    const isVisible = getComputedStyle(popup).display !== 'none' &&
                        getComputedStyle(popup).visibility !== 'hidden' &&
                        getComputedStyle(popup).opacity !== '0';

                    if (isVisible && popup.classList.contains('popup--overlay') && !popupOpened) {
                        popupOpened = true;
                        console.log('🎯 POPUP FAIRLY MADE OUVERTE !');

                        if (typeof gtag !== 'undefined') {
                            gtag('event', 'fairly_made_popup_opened', {
                                'event_category': 'fairly_made',
                                'event_label': 'popup_display',
                                'value': 1
                            });
                            console.log('📊 GA Event envoyé: fairly_made_popup_opened');
                        }
                        setTimeout(function () {
                            const iframe = popup.querySelector('iframe[src*="fairlymade"]');
                            if (iframe) {
                                console.log('🎯 IFRAME FAIRLY MADE CHARGÉE !');

                                if (typeof gtag !== 'undefined') {
                                    gtag('event', 'fairly_made_iframe_loaded', {
                                        'event_category': 'fairly_made',
                                        'event_label': 'iframe_content_loaded',
                                        'value': 1
                                    });
                                    console.log('📊 GA Event envoyé: fairly_made_iframe_loaded');
                                }
                            }
                        }, 500);
                    } else if (!isVisible && popupOpened) {
                        popupOpened = false;
                    }
                }
            });
        });

        const closeButton = popupOverlay.querySelector('.popup--close');
        if (closeButton) {
            closeButton.addEventListener('click', function () {
                popupOpened = false;
                console.log('🎯 POPUP FERMÉE !');

                if (typeof gtag !== 'undefined') {
                    gtag('event', 'fairly_made_popup_closed', {
                        'event_category': 'fairly_made',
                        'event_label': 'popup_close',
                        'value': 1
                    });
                    console.log('📊 GA Event envoyé: fairly_made_popup_closed');
                }
            });
        } else {
            console.log('❌ Bouton de fermeture non trouvé');
        }

        popupObserver.observe(popupOverlay, {
            attributes: true,
            attributeFilter: ['style', 'class']
        });

    } else {
        console.log('❌ Popup overlay non trouvé');
    }

    console.log('✅ Tracking Fairly Made configuré avec succès !');
});

window.addEventListener('error', function (e) {
    console.error('❌ Erreur dans le script Fairly Made:', e.error);
});

window.addEventListener('beforeunload', function () {
    console.log('🧹 Nettoyage du tracking Fairly Made...');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mashvp-faq"] && !Shopify.designMode) return;
  try {
    

class AnchorMenu extends HTMLElement {
  constructor() {
    super();

    this.data = [];

    this.querySelectorAll('aside li').forEach((el, i)=>{
      let tmp = {};
      tmp.btn = el
      const target = el.getAttribute('target');
      tmp.ctn = this.querySelector(`.paragraph.${target}`);
      this.data[i] = tmp;
      el.addEventListener('click', (e)=>this.update(this.data[i]));
    });

    window.addEventListener("load", (event) => {
      window.addEventListener('resize', ()=>this.resize());
      this.resize();
  
      window.addEventListener('scroll', ()=>this.scroll());
      this.scroll();
    });


  }

  resize() {
    const margin = window.innerHeight * 0.2 + 60;
    // const margin = 0;
    this.data.forEach((el, i)=>{
      const bounding = el.ctn.getBoundingClientRect();
      el.top = bounding.top + window.scrollY - margin;
      el.bottom = bounding.bottom + window.scrollY - margin;
    });
    this.top = this.data[0].top;
    this.bottom = this.data[this.data.length -1].bottom;
  }

  scroll() {
    const cur = window.scrollY;
    const boolTop = cur > this.top;
    let res = 0;
    if (boolTop && cur < this.bottom) {
      this.data.forEach((el, i)=>{
        if (cur > el.top && cur < el.bottom) {
          res = i;
        }
      });
    } else {
      if (!boolTop) {
        res = 0;
      } else {
        res = this.data.length -1;
      }
    }
    this.data.forEach((el, i)=>{
      if ( i == res) {
        el.btn.classList.add('active');
        el.ctn.classList.add('active');
      } else {
        el.btn.classList.remove('active');
        el.ctn.classList.remove('active');
      }
    });

  }

  update(el) {
    window.scrollTo({
      top: el.top+1,
      behavior: 'smooth'
    });
  }

}
customElements.define('anchor-menu', AnchorMenu);



  } catch(e) { console.error(e); }
})();
})();
